"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSOCIATED_TOKEN_PROGRAM_PUBLIC_KEY = exports.TOKEN_PROGRAM_PUBLIC_KEY = exports.WRAPPED_SOL_PUBLIC_KEY = exports.MAIN_STATE = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.MAIN_STATE = 'main_state';
exports.WRAPPED_SOL_PUBLIC_KEY = new web3_js_1.PublicKey('So11111111111111111111111111111111111111112');
exports.TOKEN_PROGRAM_PUBLIC_KEY = new web3_js_1.PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
exports.ASSOCIATED_TOKEN_PROGRAM_PUBLIC_KEY = new web3_js_1.PublicKey('ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL');
